import React from 'react'
import { Breadcrumb, Heading, Divider } from '../../components/common/atoms'
import {popup_close as closebtn} from '../../assets/images'

const EmployeeDataHoc = ({title, liner, breadcrumb, close, children, classes}) => {
  return (
    <div className={`p-8 bg-gray-100 min-h-screen ${classes}`}>
      <img src={closebtn} alt='close-btn' className='absolute right-8 cursor-pointer h-8 w-8' onClick={close} />

      <Breadcrumb list={breadcrumb} classes='mb-2 mt-0' />
      <Heading mainHeading={title} mainClasses='text-xl text-gray-900' />
      <p className='mb-0 text-gray-600 mt-1'>{liner}</p>
      <Divider classes='w-full mt-6' />
      {children}
    </div>
  )
}

export default EmployeeDataHoc